module.exports = __webpack_public_path__ + "methedology.png?f58a019aa1db2f52f0016a24ee43c816";


//////////////////
// WEBPACK FOOTER
// ./public/img/aboutus/methedology.png
// module id = 562
// module chunks = 7